// MINT-OVERRIDE: helper not present in upstream @navios/http-zod-support.
// Triggers a browser file-download from a Blob. Pre-existing in the old fork
// and consumed by several packages (planning_v2, ai-hub, omni-trafficking,
// ai-chat). See libraries/api-zod-support/OVERRIDES.md.
export function downloadBlob(data: Blob, fileName: string) {
  const blobUrl = globalThis.URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = fileName;
  document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
  a.click();
  a.remove();
}
